import React, { useState, useMemo, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import LS from '../styles/layoutStyled';
import CS from '../styles/componentStyled';
import styled from 'styled-components';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
} from '../atom/ModalAtom';
import { userIdState, userInforRecoilState } from '../atom/TokenAtom';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { socketio } from '../api/socket.api';
import { authAPI } from '../api/axiosIndex';
import { SignInDto } from '../model/user.dto';
import { Config } from '../config';
import { Icon } from '../component/Icon';

const Login = () => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const [userId, setUserId] = useRecoilState(userIdState);
  const [myInforRecoil, setMyInforRecoil] =
    useRecoilState(userInforRecoilState);

  const navigate = useNavigate();

  const [id, setId] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (id.length === 0 || password.length === 0) {
      setError(blankMsg);
      return;
    }
    const dto: SignInDto = {
      passid: id,
      password: password,
    };

    try {
      const token = await authAPI.signIn(dto);

      sessionStorage.setItem('accessToken', token.data.accessToken);
      sessionStorage.setItem('refreshToken', token.data.refreshToken);
      sessionStorage.setItem(
        'accessExpire',
        (Date.now() + token.data.accessExpire * 1000).toString(),
      );
      sessionStorage.setItem(
        'refreshExpire',
        (Date.now() + token.data.refreshExpire * 1000).toString(),
      );

      const myInforValue = {
        passid: id,
        password: password,
      };
      setMyInforRecoil(myInforValue);

      const myInfor = await authAPI.getMyInfor();
      setUserId(myInfor.data.id);

      await socketio.signin(token.data.accessToken);

      navigate('/worknummanage');
    } catch {
      setError('아이디가 올바르지 않거나\n비밀번호가 일치하지 않습니다.');
    }
  };

  return (
    <LoginWrap>
      <div>
        <div className="logo-box img-box">
          <Icon name="LogoIcon" size="100%" color="#333" color2="#777" />
        </div>
        <form onSubmit={handleLogin}>
          <div className="input-wrap">
            <div className="input-box">
              <h3>아이디</h3>
              <input
                type="text"
                placeholder="아이디 입력"
                aria-label="아이디 입력 필드"
                value={id !== null ? id : ''}
                onChange={(e) => setId(e.target.value)}
              />
            </div>
            <div className="input-box">
              <h3>비밀번호</h3>
              <input
                type="password"
                placeholder="비밀번호 입력"
                aria-label="비밀번호 입력 필드"
                value={password !== null ? password : ''}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>
          <CS.Btn1Type1 type="submit">로그인</CS.Btn1Type1>
        </form>
        <ul className="sub-btn-box">
          <li>
            <Link to="/idsearch">아이디 찾기</Link>
          </li>
          <li>
            <Link to="/passwordsearch">비밀번호 찾기</Link>
          </li>
          <li>
            <Link to="/signup">회원가입</Link>
          </li>
        </ul>
      </div>
    </LoginWrap>
  );
};

export default Login;

export const LoginWrap = styled.div`
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;

  > div {
    width: 100%;
    max-width: 370px;
    box-sizing: border-box;
    padding: 0 20px;

    .logo-box {
      width: 100%;
      max-width: 153px;
      margin: 0 auto;
    }

    .input-wrap {
      margin-top: 40px;
      display: flex;
      flex-direction: column;
      gap: 12px;

      .input-box {
        h3 {
          font-weight: 700;
          font-size: 12px;
          color: #67717e;
          box-sizing: border-box;
          padding: 12px 0 0 16px;
        }

        input {
          box-sizing: border-box;
          padding: 12px 16px 16px 16px;
          border: none;
          border-bottom: 1px solid #f0f0f0;
          width: 100%;
          font-size: 16px;
          font-weight: 500;
          color: #333;
          &::placeholder {
            color: #737373;
          }
        }
      }
    }

    ${CS.Btn1Type1} {
      margin-top: 24px;
    }

    .sub-btn-box {
      width: 100%;
      margin-top: 8px;
      display: flex;
      align-items: center;

      li {
        width: 33.3333%;
        height: 48px;
        font-size: 13px;
        font-weight: 500;
        color: #222;
        text-align: center;
        line-height: 16px;
        box-sizing: border-box;
        position: relative;
        &:not(:last-child)::after {
          content: '';
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 1px;
          height: 16px;
          background: #dbdbdb;
        }
        > a {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
`;
